import { render } from "./FlexibleLayout.vue?vue&type=template&id=5f23c4ec"
import script from "./FlexibleLayout.vue?vue&type=script&lang=js"
export * from "./FlexibleLayout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__